import { render, staticRenderFns } from "./StockDetailModal.vue?vue&type=template&id=9fadb7ec&"
import script from "./StockDetailModal.vue?vue&type=script&lang=js&"
export * from "./StockDetailModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports